import { Deployment, DeploymentStatus, DeploymentStatusError, TaskStatus } from '@back4app2/sdk';
import { useEffect, useState } from 'react';
import back4app2 from '../back4app2';
import Button from "./Button"
import Modal from "./Modal";

interface CancelBuildProps {
  deployment: Deployment;
}

const inProgressDeploymentStatus = [DeploymentStatus.INITIALIZING, DeploymentStatus.INITIALIZED, DeploymentStatus.DEPLOYING, DeploymentStatus.QUEUED];

const CancelBuildButton = ({ deployment } : CancelBuildProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    return () => {
      setOpenModal(false);
      setErrorMessage('');
    }
  }, []);

  const openCancelBuildModal = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setOpenModal(true);
  }

  const onCancelBuild = async (deployment: Deployment) => {
    setErrorMessage('');
    setIsLoading(true);
    try {
      await back4app2.cancelDeploymentBuild(deployment.id);
      setOpenModal(false);
    } catch (err) {
      if (err instanceof DeploymentStatusError) {
        setErrorMessage('Sorry, the build cannot be canceled!');
      } else {
        console.error('error in cancelling the build', err);
        setErrorMessage('Sorry, something went wrong while canceling build!');
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    inProgressDeploymentStatus.includes(deployment.status) && (!deployment.deployTask || [TaskStatus.WAITING, TaskStatus.DOING].includes(deployment.deployTask.status)) ?
    <>
      <button
        className="b4-focus h-[30px] px-3 rounded-control border border-state-err/60 bg-transparent text-state-err text-ds-125 font-semibold transition-colors duration-[120ms] hover:bg-state-err/10 hover:border-state-err"
        onClick={openCancelBuildModal}
      >
        Cancel
      </button>
      {/* `hidden` while closed so this stops being a flex item: in a
          `justify-between` row it counted as a third child and shoved the
          button into the middle of the card. */}
      <div className={openModal ? '' : 'hidden'} onClick={e => e.stopPropagation()}>
        <Modal open={openModal} onClose={() => setOpenModal(false)}>
          <div className="font-semibold leading-140 text-dark text-center mb-2">Cancel build?</div>
          {errorMessage ? <div className="text-sm text-dark/70 text-center">{errorMessage}</div> : (
            <>
              <div className="text-sm text-dark/70 text-center">{deployment.id}</div>
              <div className="flex justify-center space-x-2 w-full mt-4">
                <Button className="text-dark-grey border border-light-grey text-xs px-[0.625rem] py-2 font-semibold rounded-[5px]" onClick={() => setOpenModal(false)}>No</Button>
                <button className="bg-error-red text-xs px-[0.625rem] py-2 font-semibold rounded-[5px] text-white" onClick={isLoading ? undefined : ()=> onCancelBuild(deployment)}>{isLoading ? 'Canceling...' : 'Yes, Cancel'}</button>
              </div>
            </>
          )}
        </Modal>
      </div>
    </> : null
  )
}

export default CancelBuildButton;